import React, {useMemo} from "react";
import { Styles } from "./Styles";
import useSquad from "../../Provider/useSquad";
import useGlobalSettings from "../../Provider/useGlobalSettings";
import {StatusMember} from "../../Provider/useSquadInterfaces";
import {SquadCard} from "./SquadCard";
import {HeaderTextDescription} from "./Sections/HeaderTextDescription";
import {CreateSquad} from "./Sections/CreateSquad";
import {CurrentPlayer} from "./Sections/CurrentPlayer";
import {Summary} from "./Sections/Summary";

export interface iActivePlayer {
	id: string;
	name: string;
}

export const statusLabels: Record<StatusMember, string> = {
	[StatusMember.alive]: "Lebend",
	[StatusMember.injured]: "Verletzt",
	[StatusMember.dead]: "Gefallen",
};

export const Squad = () => {

	const { user } = useGlobalSettings()
	const { squads } = useSquad();

	const activePlayer = useMemo(() => ({
		id: user.uuid,
		name: user.name
	}), [user.uuid, user.name]) as iActivePlayer;

	const OwnSquad =
		squads.find( squad => squad.members.find(member => member.id === user.uuid ) );

	return (
		<Styles.Page>

			<Styles.CommandPanel>
				<CurrentPlayer activePlayer={ activePlayer } />
			</Styles.CommandPanel>

			<Summary />

			{squads.length === 0 ? (
				<Styles.EmptyState>
					Noch keine Squads vorhanden. Erstelle dein erstes Einsatzteam.
				</Styles.EmptyState>
			) : (
				<Styles.Grid>
					<SquadCard squadID={ OwnSquad?.id } mySquad />
					{
						squads
							.filter( squad => squad.id !== OwnSquad?.id )
							.map( squad => <SquadCard squadID={ squad.id } /> )
					}
				</Styles.Grid>
			)}
		</Styles.Page>
	);
};